import { Modal, Button, DropDown } from 'Common/Supplyvue-ui'
import { Box } from '@mui/material'
import { DownloadDataView } from 'Features/OperationalPlanner/DownloadDataModal/DownloadData.view'
import { DataDownloadModalProps } from 'Features/OperationalPlanner/DownloadDataModal/DownloadDataModal.types'
import { SET_FILE_FORMAT, FILE_FORMATS } from './DownloadData.constants'

export const DownloadDataModal = ({
  planId,
  isModalOpen,
  handleModalSave,
  handleModalCancel,
  heading,
  dataDownloadSettingsState,
  updateState,
  fileNameLabel,
  fileVersionLabel,
  keyFiguresLabel,
  fileNames,
  keyFigureItems,
  keyFigureLabels,
  onWorkcentreKeys,
}: DataDownloadModalProps) => {
  const body = (
    <>
      <Box
        sx={{
          minWidth: '600px',
          maxWidth: '900px',
        }}
      >
        <DownloadDataView
          planId={planId}
          fileNameLabel={fileNameLabel}
          fileVersionLabel={fileVersionLabel}
          keyFiguresLabel={keyFiguresLabel}
          fileName={dataDownloadSettingsState.fileName}
          fileVersion={dataDownloadSettingsState.fileVersion}
          keyFigures={dataDownloadSettingsState.keyFigures}
          workcentres={dataDownloadSettingsState.workcentres}
          dataDownloadSettingsState={dataDownloadSettingsState}
          updateState={updateState}
          fileNames={fileNames}
          keyFigureItems={keyFigureItems}
          keyFigureLabels={keyFigureLabels}
          onWorkcentreKeys={onWorkcentreKeys}
        />
      </Box>
    </>
  )

  const footer = (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          justifyContent: 'space-between',
        }}
      >
        <Button
          onClick={handleModalCancel}
          variant="outlined"
          sx={{
            width: 'max-content',
            alignSelf: 'flex-end',
            marginRight: '15px',
          }}
        >
          Cancel
        </Button>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <Button
            sx={{
              width: 'max-content',
              alignSelf: 'flex-end',
              marginRight: '15px',
            }}
            onClick={handleModalSave}
            variant="contained"
          >
            Download
          </Button>
          {
            <DropDown
              id={fileNameLabel}
              sx={{
                display: 'flex',
                height: '40px',
              }}
              value={dataDownloadSettingsState.fileFormat || 'csv'}
              menuItems={FILE_FORMATS}
              label={fileNameLabel}
              onChange={(e) =>
                updateState({
                  type: SET_FILE_FORMAT,
                  payload: e.target.value as string,
                })
              }
            />
          }
        </div>
      </Box>
    </>
  )

  return (
    <Modal
      open={isModalOpen}
      header={heading}
      handleClose={handleModalCancel}
      body={body}
      footer={footer}
    ></Modal>
  )
}
